import * as React from "react";
import { Page, Button } from "tabler-react";
import TradesSiteWrapper from "./TradesSiteWrapper.react";

export default function Error404Page() {
  return (
    <TradesSiteWrapper>
      <Page.Content title="404" subTitle="Page not found">
        <Button href="/" RootComponent="a" color="primary">
          Back to dashboard
        </Button>
      </Page.Content>
    </TradesSiteWrapper>
  );
}
